// extracted by mini-css-extract-plugin
export var button = "_28-1";
export var featuredLink = "_28-4";
export var spinner = "_28-2";
export var spinnerContainer = "_28-3";
export var text = "_28-0";